import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDrawer, MatDialog, MatSnackBar } from '@angular/material';
import { DrawerService } from '../drawer.service';
import { CartService } from 'src/app/services/cart.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { LoginComponent } from '../auth/login/login.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit, OnDestroy {

  public baskets = [];
  private basketsSub: Subscription;

  public leaves = [];
  private leaevsSub: Subscription;

  public dressings = [];
  private dressingsSub: Subscription;

  price: number = 0;
  private priceSub: Subscription;

  totalObj = {
    total: 0,
    subtotal: 0,
    fees: [],
    oneDeliveryTotal: 0
  };

  totalObjSub: Subscription;

  subscriptionType: string = '';

  totalCount: number = 0
  public totalCountSub: Subscription;

  checked: boolean;

  isAuthenticated: boolean = false;
  isAuthenticatedSub: Subscription;

  subscriptionButtonSub: Subscription;

  @ViewChild('drawer', { static: true }) drawer: MatDrawer;

  constructor(private authService: AuthService, private snackBar: MatSnackBar, private drawerStateService: DrawerService, private cartService: CartService, private dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    // open or close drawer
    this.drawerStateService.getDrawerState().subscribe(result => {
      if (result) {
        this.drawer.toggle()
      }
    });

    // get cart details on load
    this.baskets = [];
    this.leaves = [];
    this.dressings = [];

    const onloadData = this.cartService.onLoad();

    this.baskets = onloadData.baskets || [];
    this.leaves = onloadData.leaves || [];
    this.dressings = onloadData.dressings || [];
    this.price = onloadData.price;
    this.totalCount = onloadData.totalCount;

    // subscription toggle
    const subscriptionType = localStorage.getItem('subscriptionType');
    this.subscriptionType = subscriptionType;

    if (subscriptionType == '') {
      this.checked = false;
    } else {
      if (this.subscriptionType == 'One Delivery') {
        this.checked = false;
      } else {
        this.checked = true;
      }
    }

    // subscribe to baskets subject
    this.basketsSub = this.cartService.getBasketsUpdated().subscribe(result => {
      this.baskets = result;
    });

    // subscribe to leaves subject
    this.leaevsSub = this.cartService.getLeavesUpdated().subscribe(result => {
      this.leaves = result;
    });

    // subscribe to dressings subject
    this.dressingsSub = this.cartService.getDressingsUpdated().subscribe(result => {
      this.dressings = result;
    });

    // subscribe to price subject
    this.priceSub = this.cartService.getPriceUpdated().subscribe(result => {
      this.price = result;
    });

    // subscribe to total count subject
    this.cartService.getTotalCountUpdated().subscribe(result => {
      this.totalCount = result;
    });

    // subscribe to user authenticated subject
    this.isAuthenticatedSub = this.authService.getIsUserAuthenticatedUpdated().subscribe(result => {
      this.isAuthenticated = result;
    })

    this.isAuthenticated = this.authService.getIsUserAuthenticated();

    // subscribe to user authenticated subject
    this.isAuthenticatedSub = this.authService.getIsUserAuthenticatedUpdated().subscribe(result => {
      this.isAuthenticated = result;
    });

    this.totalObjSub = this.cartService.getTotalObjUpdated().subscribe(result => {
      this.totalObj = result;
    });

    this.subscriptionButtonSub = this.cartService.getSubscriptionButtonChanged().subscribe(result => {
      if (result) {
        this.checked = true;
        this.subscriptionType = 'Subscription'
        localStorage.setItem('subscriptionType', this.subscriptionType.toString());
      } else {
        this.checked = false;
        this.subscriptionType = 'One Delivery'
        localStorage.setItem('subscriptionType', this.subscriptionType.toString());
      }
      this.cartService.onSubscriptionTypeChange();
    });
  }

  onRemove(Type: string) {
    this.cartService.remove(Type);
  }

  onCloseCart() {
    this.drawer.toggle();
  }

  onCheckout() {

    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    localStorage.setItem('clickedStatus', 'checkout');

    if (!localBaskets && !localLeaves && !localDressings) {
      this.snackBar.open('Cart is empty!', 'Dismiss', {
        duration: 3000
      })
      return;
    }

    if (this.isAuthenticated) {
      this.drawer.toggle();
      this.router.navigate(['/checkout']);
    } else {
      this.dialog.open(LoginComponent);
      return;
    }
  }

  onMonthlySubscription(event) {
    this.cartService.setSubscriptionButtonChange(event.checked);
    if (event.checked) {
      this.subscriptionType = 'Subscription'
      localStorage.setItem('subscriptionType', this.subscriptionType.toString());
    } else {
      this.subscriptionType = 'One Delivery'
      localStorage.setItem('subscriptionType', this.subscriptionType.toString());
    }
    this.cartService.onSubscriptionTypeChange();
  }

  onIncrease(ID, Type) {
    this.cartService.increaseQuantity(ID, Type);
  }

  onDecrease(ID, Type) {
    this.cartService.decreaseQuantity(ID, Type);
  }

  ngOnDestroy() {
    this.basketsSub.unsubscribe();
    this.leaevsSub.unsubscribe();
    this.dressingsSub.unsubscribe();
    this.priceSub.unsubscribe();
    this.totalCountSub.unsubscribe();
    this.isAuthenticatedSub.unsubscribe();
    this.totalObjSub.unsubscribe();
    this.subscriptionButtonSub.unsubscribe();
  }
}
